module.exports = {"150303001":"拉僧仲街道","150303002":"西卓子山街道","150303102":"公乌素镇","150303103":"拉僧庙镇","150303104":"巴音陶亥镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/150303.json
// module id = 368
// module chunks = 0